import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from '../service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IAdvisor } from '../advisor';
@Component({
  selector: 'app-advisors',
  templateUrl: './advisors.component.html',
  styleUrls: ['./advisors.component.scss']
})
export class AdvisorsComponent implements OnInit {

  // The question, which will be displayed
  question;
  user;
  progressnumber: number = 10;
  counter: number = 0;
  isShown: boolean = false;
  // A form group used to handle the answers as option inputs
  form: FormGroup;
  advisors;
  questions;
  logo: any;
  activatedRoute: any;
  homePage: any;
  description: any;
  startBtn: any;
  subTitle: any;
  title: any;
  advisorsList = [];
  _listFilter: string;
  filterAdvisors: IAdvisor[];

  constructor(
    private route: ActivatedRoute,
    public quiz: Service,
    public FB: FormBuilder,
    public router: Router,
    public translate: TranslateService,

  ) {
    this.changeLang(this.translate.currentLang);
  }


  ngOnInit(): void {

  }
  getAdvisors(): void {
    this.quiz.getAdvisors()
      .subscribe(advisor => {
        this.advisors = advisor;
        this.filterAdvisors = this.advisors.advisor;
      });
  }

  changeLang(lang: string) {
    this.quiz.changeLang(lang);
    this.getAdvisors();
    if (lang === "en") {
      this.quiz.getQuestions()
        .subscribe(questions => {
          this.questions = questions;
          this.logo = this.questions.homePage[0].FRLOGO;
        });
    }
    else {
      this.quiz.getQuestions()
        .subscribe(questions => {
          this.questions = questions;
          this.logo = this.questions.homePage[0].FRLOGO;
        });
    }
  }
  get listFilter(): string {
    return this._listFilter;
  }
  set listFilter(value: string) {
    this._listFilter = value;
    this.filterAdvisors = this.listFilter ? this.performFilter(this.listFilter) : this.advisors.advisor;
  }

  performFilter(filterBy: string): IAdvisor[] {
    filterBy = filterBy.toLocaleLowerCase();
    return this.advisors.advisor.filter((advisor: IAdvisor) =>
      advisor.name.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }

}
